<!--<splash-screen></splash-screen>-->

<router-outlet></router-outlet>

<!-- One instance for the whole application; any component raises it via LoaderService. -->
<app-global-loader></app-global-loader>
